<template>
  <div>
    <Breadcrumbs :title="title"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 mb-3">
          <h3>{{ moment(month,'MM').format('MMMM') }} {{ year }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4" v-for="(stock, i) in stocks" :key="i+'-'+stock.stock">
          <div class="card">
            <highcharts class="chartWrapper" :constructor-type="'stockChart'" :options="charts[i]"></highcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require("moment")

export default {
  data: function () {
    return {
      year: this.$route.query.year || moment().format('YYYY'),
      month: this.$route.query.month || moment().format('MM'),
      fromdate: moment().subtract(30,'days').format('YYYY-MM-DD'),
      order: this.$route.query.order || 'score3',
      limit: this.$route.query.limit || 30,
      stocks: [],
      charts: []
    }
  },
  computed: {
    title: function () { return 'Multi View - Hourly Volatility' }
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchH1Volatility()
    },
    fetchH1Volatility() {
      let url = `/api/stock/scan/h1_volatility?year=`+this.year+'&month='+this.month+'&order='+this.order+'&limit='+this.limit
      this.$http.get(url)
          .then(({data}) => {
            this.stocks = data.stocks.map(s => ({ ...s, data:[] }))
            this.charts = data.stocks.map(s => ({
              chart: {
                zoomType: 'x',
                height: 600
              },
              title: {
                text: s.stock + ' ' + s.name
              },
              subtitle: {
                text: ''
              },
              navigator: {
                enabled: false
              },
              yAxis: [{
                labels: {
                  align: 'right',
                  x: -3
                },
                title: {
                  text: 'OHLC'
                },
                height: '60%',
                lineWidth: 2,
                resize: {
                  enabled: true
                }
              }, {
                labels: {
                  align: 'right',
                  x: -3
                },
                title: {
                  text: 'Volume'
                },
                top: '65%',
                height: '35%',
                offset: 0,
                lineWidth: 2
              }],
              tooltip: {
                split: true
              },
              credits: { enabled: false },
              series: [{
                type: 'candlestick',
                name: '',
                id: '',
                data: []
              }, {
                type: 'column',
                name: 'Volume',
                data: [],
                yAxis: 1
              }]
            }))
            for (let i=0; i<this.stocks.length; i++) {
              this.fetchChart(this.stocks[i].stock, i, this.stocks[i].stock+' '+this.stocks[i].name + ' - H'+this.stocks[i].hour)
            }
          })
          .catch(e => console.log(e.message))
    },
    fetchChart(id, i, title) {
      let url = `/api/stock/chart/`+id+`?year=`+this.year+'&month='+this.month+'&title='+title
      if(!this.$route.query.month) {
        url = `/api/stock/chart/`+id+`?fromdate=`+this.fromdate+'&title='+title
      }
      this.$http.get(url)
          .then(({data}) => {
            this.charts[i] = data.chart
            this.charts = [ ...this.charts ]
          })
    },
    moment() {
      return moment()
    }
  }
}
</script>